import { IDropdownOptions } from "@poste-click-connect/shared-ui";

export const emptyValueDropdown: IDropdownOptions<null> = {
  label: '',
  payload: null,
  id: '',
};

export const allValueDropdown: IDropdownOptions<null> = {
  label: 'Tutti',
  payload: null,
  id: 'all',
};


export const handleDownloadFileName = (contextName: string, sigla: string): string => {
  return `${sigla}_${contextName}_`;
}
